<template>
  <div class="hov">
  <div @click="$router.push(link)" class="panel cursor-pointer" :class="statusClass" :id="item._id">
    <div class="panel-header">
        <q-icon :name="statusIcon" color="white" size="20px" />
        <span class="text-white">&nbsp;{{workDateLabel}}&nbsp;</span>
        <small>{{item.label}}</small>
    </div>
    <div class="panel-body">
        <p>
          <unit-path v-if="needPath" :id="item.parent_id" :withoutLink="true"></unit-path>
        </p>
      <p>
        <q-icon name="fa-bell" color="grey" /> <span>{{item.problem}}</span>
      </p>
      <p v-if="item.tasks">
        <q-icon name="build" color="grey" />&nbsp;<span>{{item.tasks}}</span>
      </p>
      <p v-else>
        <q-icon  v-if="item.result" name="done" color="grey" />&nbsp;<span>{{item.result}}</span>
      </p>
    </div>
  </div>
  </div>
</template>

<style scoped>
</style>

<script type="text/babel">
// import utils from '../utils.js'
import UnitPath from './unit-path.vue';

export default {
  name: 'caseitem',
  components: {
    UnitPath,
  },
  props: ['item', 'needPath'],
  data() {
    return {};
  },
  computed: {
    link() {
      if (this.$route.name === 'unitView' || this.$route.name === 'resultView') {
        return `/ic/${this.$route.params.id}${this.item.link}`;
      } else if (this.$route.params.iid) {
        return `/ic/${this.$route.params.iid}${this.item.link}`;
      }
      return `/c/${this.$route.params.filter}${this.item.link}`;
    },
    statusClass() {
      return this.$utils.statusClass(this.item.status, this.item.workDate);
    },
    statusIcon() {
      return this.$utils.statusIcon(this.item.status);
    },
    workDateLabel() {
      if (this.item.workDate) {
        const d = new Date(this.item.workDate);
        return ` ${d.toLocaleDateString('ru')}`;
      }
      return '';
    },
  },
  methods: {

  },
};
</script>



// WEBPACK FOOTER //
// src/components/case-item.vue